import { render } from "./Index.vue?vue&type=template&id=0ba0ab60"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Auth/Login/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ba0ab60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ba0ab60', __exports__)) {
    api.reload('0ba0ab60', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=0ba0ab60", () => {
    api.rerender('0ba0ab60', render)
  })

}


export default __exports__